import { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useSubscription = (feature) => {
  const [canUse, setCanUse] = useState(true);
  const [limit, setLimit] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  useEffect(() => {
    checkLimit();
  }, [feature]);

  const checkLimit = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        setCanUse(true);
        setLoading(false);
        return;
      }

      const response = await axios.post(
        `${API}/subscription/check-limit`,
        { feature },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.data.success) {
        setCanUse(response.data.allowed);
        setLimit({
          allowed: response.data.allowed,
          remaining: response.data.remaining,
          max: response.data.limit,
          resetAt: response.data.resetAt,
          current: response.data.limit - response.data.remaining
        });
      }
    } catch (error) {
      console.error('Failed to check limit:', error);
      // Default to allowing on error
      setCanUse(true);
    } finally {
      setLoading(false);
    }
  };

  const checkAndIncrement = async () => {
    await checkLimit();
    
    if (!canUse) {
      setShowUpgradeModal(true);
      return false;
    }

    try {
      const token = localStorage.getItem('token');
      if (token) {
        await axios.post(
          `${API}/subscription/increment-usage`,
          { feature },
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }
      return true;
    } catch (error) {
      console.error('Failed to increment usage:', error);
      return true; // Allow on error
    }
  };

  return {
    canUse,
    limit,
    loading,
    showUpgradeModal,
    setShowUpgradeModal,
    checkLimit,
    checkAndIncrement
  };
};
